// extracted by css-extract-rspack-plugin
export default {"wrapper":"Logo-module__wrapper--STKBw","medium":"Logo-module__medium--N4Tn1","small":"Logo-module__small--YmzKb"};